/** 后台未上传封面时使用站点 logo */
const DEFAULT_COVER = '/static/logo.png'

export function getVideoCover(item) {
  const url = item && (item.imgUrl || item.img_url)
  if (url && String(url).trim()) {
    const u = url.trim()
    if (u.startsWith('http') || u.startsWith('/') || u.startsWith('data:')) {
      return u
    }
  }
  return DEFAULT_COVER
}

export function handleCoverError(e) {
  if (e && e.target && e.target.src !== DEFAULT_COVER) {
    e.target.src = DEFAULT_COVER
  } else if (e && e.target) {
    e.target.onerror = null
  }
}
